import { render, staticRenderFns } from "./bindBot.vue?vue&type=template&id=92e0afc0&scoped=true"
import script from "./bindBot.vue?vue&type=script&lang=js"
export * from "./bindBot.vue?vue&type=script&lang=js"
import style0 from "./bindBot.vue?vue&type=style&index=0&id=92e0afc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e0afc0",
  null
  
)

export default component.exports